import { render, staticRenderFns } from "./UpdatedChanges.vue?vue&type=template&id=7b8dd79e&"
import script from "./UpdatedChanges.vue?vue&type=script&lang=js&"
export * from "./UpdatedChanges.vue?vue&type=script&lang=js&"
import style0 from "./UpdatedChanges.vue?vue&type=style&index=0&id=7b8dd79e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports